import {Button, Container, DropdownItemProps, DropdownProps, Form, Icon, Table,} from "semantic-ui-react";

import React, {useEffect, useState} from "react";
import {AppListPageDialogContext, AppListPageDialogContextState} from "../../common/AppListPage";
import {
    SurveySelectionConditionAction,
    SurveySelectionConditionActionToString,
    SurveySelectionConditionAnswerOperator,
    SurveySelectionConditionAnswerOperatorToString,
    SurveySelectionConditionModel
} from "../model/SurveySelectionModel";
import {SurveyCampaignModel} from "../model/SurveyCampaignModel";
import {SurveyFormModel, SurveyFormQuestionType} from "../model/SurveyFormModel";
import {SurveyCampaignDataProvider} from "../service/SurveyCampaignDataProvider";
import {SurveyFormDataProvider} from "../service/SurveyFormDataProvider";
import {flattenQuestions} from "../form/SurveyFormEditor";

interface Props {
    context: AppListPageDialogContext<SurveySelectionConditionModel>
}

const SurveySelectionConditionDetails = (props: Props) => {

    const [model, setModel] = useState<SurveySelectionConditionModel | undefined>(props.context.model);
    const [campaignId, setCampaignId] = useState<string | undefined>(props.context.model?.campaign?.id);
    const [campaigns, setCampaigns] = useState<SurveyCampaignModel[]>([]);
    const [form, setForm] = useState<SurveyFormModel | undefined>();
    const [action, setAction] = useState<SurveySelectionConditionAction | undefined>(props.context.model?.action);
    const [loaded, setLoaded] = useState(false);
    const [campaignError, setCampaignError] = useState<string | undefined>();

    useEffect(() => {
        loadCampaigns().then(() => {
            setLoaded(true);
        });
        loadForm().then(r => {
        });
    }, []);

    useEffect(() => {
        if (loaded) {
            let campaign: SurveyCampaignModel | undefined;
            campaign = campaigns.find((x) => x.id == campaignId);

            setModel(Object.assign(props.context.model, {
                campaign: campaign,
                action: action
            }));
        }
    }, [campaignId, action]);

    useEffect(() => {
        loadForm();
    }, [campaignId]);

    async function validate(): Promise<boolean> {
        let result = true;
        setCampaignError(undefined);
        if (!campaignId) {
            setCampaignError("Выберите кампанию");
            result = false;
        }
        return result;
    }

    async function loadCampaigns(): Promise<void> {
        const result = await (new SurveyCampaignDataProvider()).list({page: 1, limit: 999999, sort: "-created"});
        setCampaigns(result.items);
    }

    async function loadForm(): Promise<void> {
        if (campaignId) {
            const campaign = await (new SurveyCampaignDataProvider()).getByID(campaignId);
            const result = await (new SurveyFormDataProvider()).getByID(campaign!.form!.id);
            setForm(result)
        }
    }

    props.context.validateCallback = validate;

    const readOnly = props.context.state == AppListPageDialogContextState.view;

    function getAnswerFormAnswers(id: string | undefined): DropdownItemProps[] {
        if (id && form) {
            const formAnswers = flattenQuestions(form.questions);
            const fa = formAnswers.find((x) => x.id === id);
            if (fa && fa.type == SurveyFormQuestionType.choice) {
                return fa.choices.map((c) => {
                        return {
                            value: c.value,
                            text: c.displayText
                        } as DropdownItemProps;
                    }
                )
            }
            if (fa && fa.type == SurveyFormQuestionType.bool) {
                return [true, false].map((c) => {

                        return {
                            value: c.toString(),
                            text: c ? (fa.buttonTrueDisplayText ?? "ДА") : (fa.buttonFalseDisplayText ?? "НЕТ")
                        } as DropdownItemProps;
                    }
                )
            }

        }
        return [];
    }

    return <Container fluid>
        <Form>
            <Form.Group>
                <Form.Dropdown label={"Кампания:"}
                               selection
                               required
                               disabled={readOnly}
                               value={campaignId}
                               error={campaignError}
                               onChange={async (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                   await setCampaignId(data.value?.toString());
                                   await loadForm();
                                   setModel(Object.assign({}, model));
                               }}
                               options={campaigns?.map((x) => ({
                                   campaign: x,
                                   form: x.form,
                                   value: x.id,
                                   text: x.name
                               } as DropdownItemProps))}/>
                <Form.Dropdown label={"Действие:"}
                               selection
                               required
                               disabled={readOnly}
                               value={action}
                               onChange={async (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                   setAction(data.value as SurveySelectionConditionAction);
                               }}
                               options={[SurveySelectionConditionAction.include, SurveySelectionConditionAction.exclude].map((x) => ({
                                   value: x,
                                   text: SurveySelectionConditionActionToString(x)
                               } as DropdownItemProps))}/>
            </Form.Group>
            <Button content={"Добавить"} disabled={readOnly} onClick={() => {
                model?.answers?.push({
                    operator: SurveySelectionConditionAnswerOperator.equals
                });
                setModel(Object.assign({}, model));
            }}/>
            <Table>
                <Table.Header>
                    <Table.HeaderCell width={6}>Вопрос</Table.HeaderCell>
                    <Table.HeaderCell width={4}>Оператор</Table.HeaderCell>
                    <Table.HeaderCell width={6}>Значение</Table.HeaderCell>
                    <Table.HeaderCell width={1}>&nbsp;</Table.HeaderCell>
                </Table.Header>
                <Table.Body>
                    {model?.answers?.map((answer) => <Table.Row>
                        <Table.Cell>
                            <Form.Dropdown
                                selection
                                required
                                disabled={readOnly}
                                value={answer.question?.id}
                                onChange={async (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                    if (data.value) {
                                        const question = flattenQuestions(form?.questions ?? [])?.find((x => x.id === data.value));
                                        if (question) {
                                            answer.question = {
                                                id: question.id,
                                                name: question.questionDisplayText
                                            };
                                            answer.value = undefined;
                                            setModel(Object.assign({}, model));
                                        }

                                    }
                                }}
                                options={flattenQuestions(form?.questions ?? []).map((x) => ({
                                    question: x,
                                    value: x.id,
                                    text: x.questionDisplayText
                                } as DropdownItemProps))}/>
                        </Table.Cell>
                        <Table.Cell>
                            <Form.Dropdown
                                selection
                                required
                                disabled={readOnly}
                                value={answer.operator}
                                onChange={async (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                    if (data.value) {

                                        answer.operator = data.value as SurveySelectionConditionAnswerOperator;
                                        answer.value = undefined;
                                        setModel(Object.assign({}, model));
                                    }

                                }
                                }
                                options={[
                                    SurveySelectionConditionAnswerOperator.equals,
                                    SurveySelectionConditionAnswerOperator.notNull,
                                    SurveySelectionConditionAnswerOperator.isNull,
                                    SurveySelectionConditionAnswerOperator.inList
                                ].map((x) => ({
                                    value: x,
                                    text: SurveySelectionConditionAnswerOperatorToString(x)
                                } as DropdownItemProps))}/>
                        </Table.Cell>
                        <Table.Cell>
                            <Form.Dropdown
                                selection
                                multiple={answer.operator == SurveySelectionConditionAnswerOperator.inList}
                                required
                                disabled={readOnly ||
                                    answer.operator == SurveySelectionConditionAnswerOperator.notNull ||
                                    answer.operator == SurveySelectionConditionAnswerOperator.isNull}
                                value={answer.operator == SurveySelectionConditionAnswerOperator.inList ?
                                    (answer.value?.toString()?.split(",") ?? []) : answer.value}
                                onChange={async (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                    answer.value = data.value?.toString();
                                    setModel(Object.assign({}, model));

                                }}
                                options={getAnswerFormAnswers(answer.question?.id)}/>

                        </Table.Cell>
                        <Table.Cell>
                            <Icon name={"delete"} color={"red"} disabled={readOnly} onClick={() => {
                                const index = model?.answers?.indexOf(answer);
                                if (index >= 0) {
                                    model?.answers?.splice(index, 1);
                                    setModel(Object.assign({}, model));
                                }
                            }}/>
                        </Table.Cell>
                    </Table.Row>)}
                </Table.Body>
            </Table>
        </Form>
    </Container>;
}

export default SurveySelectionConditionDetails;